import * as angular from 'angular';
import { GradPlanningWizardDropdownModule } from './grad-planning-wizard-dropdown/grad-planning-wizard-dropdown.module';
import { GradPlanningWizardStepperModule } from './grad-planning-wizard-stepper/grad-planning-wizard-stepper.module';
import { GradPlanningWizardTableModule } from './grad-planning-wizard-table/grad-planning-wizard-table.module';
import { GradPlanningWizardComponent } from './grad-planning-wizard.component';

export const GradPlanningWizardModule = angular
  .module('gradPlanningWizard', [
    GradPlanningWizardDropdownModule,
    GradPlanningWizardStepperModule,
    GradPlanningWizardTableModule,
  ])
  .component('gradPlanningWizard', GradPlanningWizardComponent).name;
